import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {NamedLogger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {gsap} from "gsap";

type soundConfig = {
    volume?:number,
    fadeVolume?:number,
    repeat?:number,
    fadeDuration?:number,
}

export class FlightModeSound {

    public static INTRO_MUSIC = "loaderLoop";
    public static BASE_GAME_MUSIC:string = "background_music_main";
    public static FREESPINS_MUSIC:string = "background_music_fs";
    public static getFreespinsMusic(scatterCount:number) {
        return `background_music_fs${scatterCount == 3 ? 6 : scatterCount == 4 ? 9 : 12}`;
    }

    static WIN_TINY_START:string = "winStart";
    static WIN_SMALL_START:string = "winStart";
    static WIN_MEDIUM_START:string = "winStart";
    static WIN_LARGE_START:string = "winStart";
    static WIN_TINY:string = "winTiny";
    static WIN_SMALL:string = "winSmall";
    static WIN_MEDIUM:string = "winMediumCountUp";
    static WIN_LARGE:string = "winLargeCountUp";
    static WIN_TINY_END:string = "";
    static WIN_SMALL_END:string = "";
    static WIN_MEDIUM_END:string = "winMediumEnd";
    static WIN_LARGE_END:string = "winLargeEnd";

    static BIG_WIN_END:string = "bigWinEnd";
    static BIG_WIN_CHANGE:string = "bigWinLevelChange";
    static CONTINUE_BUTTON:string = "continueButton";

    private currentMusic:string;
    private alreadyPlayingSound:Set<string> = new Set<string>();
    private player:NolimitAudioPlayer = <NolimitAudioPlayer>SlotGame.sound;
    private logger:NamedLogger = new NamedLogger("FMSound");

    private static createConfig(name:string, args:soundConfig = {}) {
        return {
            name:name,
            volume:args.volume,
            fVolume:args.fadeVolume,
            repeat:args.repeat,
            fadeDurr:args.fadeDuration
        }
    }

    public playLoopingSound(name:string, args:soundConfig = {}) {
        this.playAndGetSound(name, args)?.setLoop(true);
    }

    public playSound(name:string, args:soundConfig = {}) {
        if (!this.alreadyPlayingSound.has(name)) {
            this.playAndGetSound(name, args);
            this.alreadyPlayingSound.add(name);
            gsap.timeline().add(() => {
                this.alreadyPlayingSound.delete(name)
            }, 0.01);
        }
    }

    public playAndGetSound(name:string, args:soundConfig = {}):NolimitHowl | undefined {
        this.logger.log("playSound: " + name);
        return this.player.playTrack(FlightModeSound.createConfig(name, args));
    }

    public stopSound(name:string) {
        this.player.stopTrack(name);
    }

    public switchMusic(targetMusic:string) {
        this.player.stopTrack(this.currentMusic);
        this.player.playTrack(FlightModeSound.createConfig(targetMusic, {volume:1}));
        this.currentMusic = targetMusic;
    }

    public fadeOutMusic(duration:number = 300, targetVolume:number = 0) {
        this.player.fadeTrack({
            name:this.currentMusic,
            to:targetVolume,
            duration:duration
        });
    }

    public fadeInMusic(duration:number = 300) {
        this.player.fadeTrack({
            name:this.currentMusic,
            to:1,
            duration:duration
        });
    }

}